import { jsonParse } from '@sitecore-search/common';
export default class LocalStorageHandler {
    set(key, value, expiry) {
        const data = {
            value,
            lastModifiedAt: new Date().getTime() || 0,
            expiryTime: expiry,
        };
        if (typeof value !== 'undefined') {
            localStorage.setItem(key, JSON.stringify(data));
        }
        else {
            localStorage.removeItem(key);
        }
    }
    get(key) {
        const currentTime = new Date().getTime() || 0;
        let storageData = jsonParse(localStorage.getItem(key));
        if (storageData && storageData.lastModifiedAt) {
            if (currentTime - +storageData.lastModifiedAt > +storageData.expiryTime) {
                this.remove(key);
                storageData = undefined;
            }
        }
        return storageData && storageData.value;
    }
    remove(key) {
        localStorage.removeItem(key);
    }
}
